import utils from "./utils";
import trackingUtils from "./trackingUtils";
import httpClient from "./network/httpClient";
import enums from "./enums";
import sessionUtils from "./sessionUtils";
import properties from "./properties";

let _store: any = null;
let _query: any = null;
let _$cookies: any = null;
let _initializedBy= '';
let _loginRequest: any = {}
let _loginType = enums.loginTypes.CREDENTIALS
const PROTECTED_PAGES = ["profile", "link"];
let internalRedirectionPage = '';
let thereAreStoredUntouchedCredentials = false;
let storedCredentials: any = {};
const codeVerifier = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
const appFolder = window.location.href.includes('/oneidtest') ? process.env.VUE_APP_PUBLIC_PATH.replace('/oneid', `/oneid/${process.env.VUE_APP_BLUE_TARGET_PREFIX}`) : process.env.VUE_APP_PUBLIC_PATH;

const areEpaasAndTracyEnabled = ()=>{
  const areEpaasAndTracyEnabledGlobal = _store.getters.configure("enable_epaas_&_tracy_tracking_global");
  const areEpaasAndTracyEnabledClient = _store.getters.configure("enable_epaas_&_tracy_tracking");
  if (areEpaasAndTracyEnabledGlobal && areEpaasAndTracyEnabledClient !== undefined) {
       return areEpaasAndTracyEnabledClient;
  }
  return areEpaasAndTracyEnabledGlobal;
};

const isIdTokenEnabled = () => {
  const isIdTokenEnabledGlobal = _store.getters.configure("enable_id_token_global");
  const isIdTokenEnabledClient = _store.getters.configure("enable_id_token");
  if (isIdTokenEnabledGlobal && isIdTokenEnabledClient !== undefined) {
    return isIdTokenEnabledClient;
  }
  return isIdTokenEnabledGlobal;
};

const isSSOEnabled = () => {
  const isSSOEnabledGlobal = _store.getters.configure("enable_sso_global");
  const isSSOEnabledClient = _store.getters.configure("enable_sso");
  if (isSSOEnabledGlobal && isSSOEnabledClient !== undefined) {
    return isSSOEnabledClient;
  }
  return isSSOEnabledGlobal;
};

const isCloudEnabled = () => {
  const isCloudEnabledGlobal = _store.getters.configure("enable_cloud_global");
  const isCloudEnabledClient = _store.getters.configure("enable_cloud");
  if (isCloudEnabledGlobal && isCloudEnabledClient !== undefined) {
    return isCloudEnabledClient;
  }
  return isCloudEnabledGlobal;
};

const isPromptLogout = () =>{
  return _query.prompt && _query.prompt=='login' && !_store.getters.configure('show_prompt_login_user_selection_section')
}

const isPromptLogin = () =>{
  return _query.prompt && _query.prompt=='login' && _store.getters.configure('show_prompt_login_user_selection_section')
}

const isThirdPage = () => {
  return _query.scope && _store.getters.configure('show_third_party_page');
}

const isAppLoginPage = ()=>(
  _store.getters.configure('show_applogin_page') && 
  _loginType == enums.loginTypes.CREDENTIALS &&
  !internalRedirectionPage && 
  !thereAreStoredUntouchedCredentials
);

const preConfigure = async (page)=>{
  if(PROTECTED_PAGES.includes(page)){
    let challenge = await utils.generateCodeChallenge(codeVerifier);
    _loginRequest.code_challenge=challenge;
    _loginRequest.code_challenge_method='S256';
    _loginRequest.client_id = _store.getters.configure("key_for_internal_client_id");
    _loginRequest.redirect_uri = `${appFolder}${page}/`;
    _loginRequest.response_type = 'code';
    _loginRequest.scope = properties.ALL_SCOPES;
    _loginRequest.grant_type = "authorization_code";
    const randomState = Math.random().toString(36).substring(2);
    window.localStorage.setItem("oneid_state_check", randomState);
    _loginRequest.state = randomState;

  }else{
    const clientConfig = _store.getters.getConfigurations.client;
      let clientId;
      if (clientConfig && clientConfig.client) {
        clientId = clientConfig.client.client_id;
      }
      _loginRequest.client_id =  clientId;
      _loginRequest.response_type =  "code";
      _loginRequest.scope =  _query.scope?.replaceAll('+',' ') || "";
      _loginRequest.redirect_uri =  decodeURIComponent(_query.redirect_uri) || "";
      _loginRequest.state =  _query.state || "";
      _loginRequest.nonce =  _query.nonce || "";
      _loginRequest.grant_type = "authorization_code";
      if(_query.code_challenge && _query.code_challenge_method){
        _loginRequest.code_challenge =  _query.code_challenge
        _loginRequest.code_challenge_method =  _query.code_challenge_method
      }
  }
}

const prepareLoginUrl = (url, permanent)=>{
  if(areEpaasAndTracyEnabled() && window['epaas'].api.isInitialized()){
    url = trackingUtils.prepareEpaasParameters(url);
  }

  if(_query['interaction-id'] && _query['client-version']){
    
    if(url.includes('?')){
      url = url+'&interaction-id='+_query['interaction-id']+"&client-version="+_query['client-version']
    }else{
      url = url+'?interaction-id='+_query['interaction-id']+"&client-version="+_query['client-version']
    }
  }
  if (permanent) {
    if(url.includes('?')){
      url = url+'&permanent='+permanent;
    }else{
      url = url+'?permanent='+permanent;
    }
  }
  return url;
};

const prepareForAppLoginPage = (url, mobile) => {
 //re-do call with syncronous form for server side redirect (302)

 if((isAppLoginPage() && mobile)){
   const loginInfo={
     'url':url,
     'loginRequest': {..._loginRequest}
   };
   _loginRequest.redirect_uri=process.env.VUE_APP_PUBLIC_PATH+"applogin/";
   window.sessionStorage.setItem('wantToStoreOtherCredentials',(!thereAreStoredUntouchedCredentials && !!storedCredentials.id)+'');
   window.sessionStorage.setItem('loginInfo',JSON.stringify(loginInfo));
 }else if(!internalRedirectionPage){  //if normal login flow, clean local storage
   window.localStorage.removeItem("storedParameters");
 }
};

const deleteSession = (callback?)=>{
  delete _loginRequest.id_token;
  delete _loginRequest.authorization;
  _loginType=enums.loginTypes.CREDENTIALS;
  sessionUtils.forceLogout(_store.getters.configure("key_for_internal_client_id"),callback);
};

const configureForSSO = ()=>{
  const isSSOAvailable = isSSOEnabled() || PROTECTED_PAGES.includes(internalRedirectionPage);
  const isIDToken = isIdTokenEnabled() && window.localStorage.getItem("oneid_id_token");
  if (isIDToken) {
    _loginType = enums.loginTypes.ID_TOKEN;
    _loginRequest.id_token = window.localStorage.getItem("oneid_id_token");
    window.localStorage.removeItem("oneid_id_token");
    return true;
  } else if(isSSOAvailable){
    _loginType = enums.loginTypes.COOKIE;
    return true;
  } else{
    return false;
  }
}

const configureLoginRequest = async ({initializedBy, store, $cookies})=>{
  
  _$cookies = $cookies;
  _store=store;
  _initializedBy=initializedBy
  _query=utils.getQueryParams();
  switch (initializedBy) {
    case enums.loginInitializers.LOGIN_PAGE:

      internalRedirectionPage = _query.redirectFrom;
      await preConfigure(internalRedirectionPage);
      if(isPromptLogout()){
        deleteSession();
      }else if(!configureForSSO()){
        _loginType = enums.loginTypes.CREDENTIALS;
      }
      break;
    case enums.loginInitializers.PRE_REGISTER_PAGE:
      internalRedirectionPage = 'profile';
      await preConfigure(internalRedirectionPage);
      _loginType = enums.loginTypes.CREDENTIALS;
      break;
    case enums.loginInitializers.LINK_PAGE:
      internalRedirectionPage = 'link';
      await preConfigure(internalRedirectionPage);
      configureForSSO();
      break;
    default:
      internalRedirectionPage = 'profile';
      break;
  }

  return {initialLoginRequest:_loginRequest, initialLoginType:_loginType};
};




const doAuthorizationFirstStep = (permanentLogin, hcaptchaToken?)=>{
  if(_loginType === enums.loginTypes.PASSKEY) {

     return new Promise((resolve, reject) => {
      httpClient.passkeyLoginComplete(_loginRequest.passkeyCompleteBody).then((resLoginComplete) => {
        const authorization = resLoginComplete?.data?.redirect_to.split("&").splice(-1)[0].replace("authorization=", "");
  
        if(process.env.NODE_ENV === "pmt") {
          document.cookie = "GCDMSSO=" + authorization + ";expires=Session"
          + ";domain=.bmwgroup.com;path=/";
        }
        
        _loginRequest.authorization = authorization;

        delete _loginRequest.username;
        delete _loginRequest.password;
        delete _loginRequest.grant_type;
        delete _loginRequest.passkeyCompleteBody;
        
        const error = sessionUtils.getParameterByName(resLoginComplete.request.responseURL,"error");

        if(error){
          reject({error, payload:null});
        } else {
          showMiddlePages(resolve);
        }
        
      }).catch((e) => {
        delete _loginRequest.passkeyCompleteBody;
        reject({error: e.errorCode, payload: e.errorPayload, headers: e.headers});
      });;
      
    }); 
  }
  return new Promise((resolve, reject)=>{
    httpClient.signIn(_loginRequest, permanentLogin, hcaptchaToken).then((data)=>{
      if (data.data.redirect_to) {
        _loginRequest.authorization = sessionUtils.getParameterByName(
          data.data.redirect_to,
          "authorization"
        );
      }
      delete _loginRequest.username;
      delete _loginRequest.password;
      delete _loginRequest.grant_type;
      const error = sessionUtils.getParameterByName(data.request.responseURL,"error");
      if(error){
        reject({error, payload:null});
      } else {
        showMiddlePages(resolve);
      }
    }).catch((e) => {
      reject({error: e.errorCode, payload: e.errorPayload, headers: e.headers});
    });
  });

};

const showMiddlePages = (resolve) => {
  if (isPromptLogin() && _loginType!=enums.loginTypes.CREDENTIALS && _initializedBy == enums.loginInitializers.LOGIN_PAGE) {
    resolve('prompt');
  }
  if(isThirdPage() && _initializedBy == enums.loginInitializers.LOGIN_PAGE){
    resolve('thirdparty');
  }
 resolve(null);
}

    


const prepareSecondStep = (permanent, mobile) =>{
  if (internalRedirectionPage) {
    window.localStorage.setItem("oneid_code_verifier", codeVerifier);
  }
  let url = httpClient.prepareUrl(_store.getters.configure("api_url_login"));
  if(_initializedBy == enums.loginInitializers.LOGIN_PAGE){
    url = prepareLoginUrl(url, permanent);
    prepareForAppLoginPage(url, mobile);
    if(_query?.response_type) _loginRequest.response_type=_query.response_type;
  }
  return buildForm(url);
};
const setCredentials= (credentials) =>{
  storedCredentials=credentials;
  thereAreStoredUntouchedCredentials=true;
}

const prepareCredentialsLogin = (email, password, attemptNumber?) =>{
  _loginRequest.username = email;
  _loginRequest.password = password;
  if(_loginRequest.username!==storedCredentials.id || _loginRequest.password!==storedCredentials.password){
    thereAreStoredUntouchedCredentials=false;
  }
  _loginType=enums.loginTypes.CREDENTIALS;
  return _loginType;
};

const prepareCredentialsLoginPasskey = (passkeyCompleteBody, attemptNumber?) =>{
  _loginType=enums.loginTypes.PASSKEY;
  _loginRequest.passkeyCompleteBody = passkeyCompleteBody;
  return _loginType;
};

const buildForm = (url) => {
 const form = document.createElement("form");
 form.setAttribute("enctype", "application/x-www-form-urlencoded");
 form.setAttribute("method", "post");
 form.setAttribute("action", url);
 document.body.appendChild(form);
 for (const key in _loginRequest) {
   const input = document.createElement("input");
   input.setAttribute("type", "hidden");
   input.setAttribute("name", key);
   input.setAttribute("value", _loginRequest[key]);
   form.appendChild(input);
 }
 return form;
};

const stateCheck = (_state)=>{
  const state = _state || window.localStorage.getItem("oneid_state");
  window.localStorage.getItem("oneid_state");
  const _stateCheck = window.localStorage.getItem("oneid_state_check");
  if (!state || (state && state != _stateCheck)) {
    throw new Error("state check KO");
  }else{
    window.localStorage.setItem("oneid_state", state);
  }
};

const getNewAccessToken = (code, redirectPage)=>{
  return new Promise((resolve, reject)=>{
    httpClient
    .getToken(code,_store.getters.configure("key_for_internal_client_id"),window.localStorage.getItem("oneid_code_verifier"), redirectPage)
      .then((res) => {
        if(res.data){
          window.localStorage.setItem("oneid_access_token",res.data.access_token);
          window.localStorage.setItem("oneid_refresh_token",res.data.refresh_token);
        }
        resolve('');
      })
      .catch(() => {
        reject()
      });
    });
};

const retrieveNewAccessToken = (redirectPage)=>{
  return new Promise((resolve, reject)=>{
    const refreshToken = window.localStorage.getItem("oneid_refresh_token");
    if(refreshToken){
      httpClient.refreshToken(refreshToken, _store.getters.configure("key_for_internal_client_id"),window.localStorage.getItem("oneid_code_verifier")).then(
        (res)=>{
          if(res.data){
            window.localStorage.setItem("oneid_access_token",res.data.access_token);
            window.localStorage.setItem("oneid_refresh_token",res.data.refresh_token);
          }
          resolve('');
        }
      ).catch(
        ()=>{
          sessionUtils.cleanLocalStorage();
          delete _query.register_first;
          let newQuery;
          newQuery={ ..._query, redirectFrom: redirectPage }
          reject({
            path: "login",
            query: newQuery,
          });
        }
      );
    }else{
      const code = _query.code || window.localStorage.getItem("oneid_code");
      window.localStorage.removeItem("oneid_code")
      if (code) {
        getNewAccessToken(code, redirectPage).then(()=>{
          resolve('');
        }).catch(()=>{
          sessionUtils.cleanLocalStorage();
          delete _query.register_first;
          let newQuery;
          newQuery={ ..._query, redirectFrom: redirectPage }
          reject({
            path: "login",
            query: newQuery,
          });
        });
      }else{
        sessionUtils.cleanLocalStorage();
        delete _query.register_first;
        let newQuery;
        newQuery={ ..._query, redirectFrom: redirectPage }
        reject({
          path: "login",
          query: newQuery,
        });
      }
    }
  });
}

const isTokenValid = (token) => {
  return new Promise((resolve, reject) => {
    httpClient.tokenInfo(token).then((res) => {
      resolve(res.status == 200);
    }).catch(() => {
      resolve(false);
    })
  })
}

export default {
  configureLoginRequest,
  deleteSession,
  doAuthorizationFirstStep,
  prepareSecondStep,
  prepareCredentialsLogin,
  prepareCredentialsLoginPasskey,
  setCredentials,
  stateCheck,
  retrieveNewAccessToken,
  isTokenValid
};
